import { setTour } from "@/app/store/user/reducer";
import { useEffect } from "react";
import { useAppDispatch } from "./useAppDispatch";
import { useAppSelector } from "./useAppSelector";

export function useTour(index: number) {
  const dispatch = useAppDispatch();
  const { tour } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (tour.isTourActive && tour.run == false) {
      dispatch(setTour({ run: true, stepIndex: index }));
    }
  }, [tour, dispatch, index]);
}
